import { Action, action } from 'easy-peasy'
import { components } from 'Types'

type StepChoices = components['schemas']['Status']['nextStep']
export interface State {
  currentStep: number
  currentStepName: StepChoices
  requiredSteps: StepChoices[]
}
export interface Actions {
  initializeStep: Action<this, StepChoices>
  setRequiredSteps: Action<this, StepChoices[]>
  setStep: Action<this, number>
  changeStep: Action<this, number>
}
export interface Thunks {}

export interface StepModel extends State, Actions, Thunks {}

export const stepModel: StepModel = {
  currentStep: 0,
  currentStepName: 'kerb',
  requiredSteps: [],

  // Actions

  initializeStep: action((state, payload) => {
    let step = 0
    step = getStep(payload)
    state.currentStep = step
    state.currentStepName = payload
  }),
  setRequiredSteps: action((state, payload) => {
    state.requiredSteps = payload
  }),
  setStep: action((state, payload) => {
    state.currentStep = payload
  }),
  changeStep: action((state, payload) => {
    let currentStep: number = 0
    let currentStepName: StepChoices = 'kerb'

    state.requiredSteps.forEach((stepName, index) => {
      if (stepName?.toLowerCase() === state.currentStepName?.toLowerCase()) {
        const nextIndex = index + payload
        const nextStepName = state.requiredSteps[nextIndex]
        currentStep = getStep(nextStepName)
        currentStepName = nextStepName
      }
    })
    state.currentStep = currentStep
    state.currentStepName = currentStepName
  })
}

const getStep = (stepName: StepChoices): number => {
  switch (stepName?.toLowerCase()) {
    case 'kerb':
      return 0
    case 'password':
      return 1
    case 'picture':
      return 2
    case 'duo':
      return 3
    case 'completed_onboarding':
      return 4
    case 'completed':
      return 5
    default:
      return 0
  }
}
